import { useSelector } from 'react-redux';
import { selectProductsCompareSettings } from '@client/settings/redux/redux';
import { SettingsProductsCompareType } from '@client/settings/redux/types';

export const useProductsCompareSettings = (): SettingsProductsCompareType => useSelector(selectProductsCompareSettings);
